export const FORMAT_DATE_LONG = 'DD MMMM YYYY';
export const FORMAT_DATE = 'DD-MM-YYYY';
export const INVERSE_FORMAT_DATE = 'YYYY-MM-DD';
export const FORMAT_DATE_WITH_HOURS = 'DD-MM-YYYY HH:mm';
export const LEGAL_BIRTHDAY = 18;
